<template>
  <div class="newsContent">
    <ul class="top">
      <li class="change active">
        <router-link to="/news/news1">
          <button>最新消息<i></i></button>
        </router-link>
      </li>
      <li class="change">
        <router-link to="/news/news2">
          <button>集团公告<i></i></button>
        </router-link>
      </li>
      <!-- <li class="change">
        <router-link to="/news/news3">
          <button>信息披露<i></i></button>
        </router-link>
      </li> -->
      <li class="change ">
        <router-link to="/news/news4">
          <button>公司动态<i></i></button>
        </router-link>
      </li>
    </ul>

    <div class="shownews">
      <ul>
        <li v-for="person in arr" :key="person.resourceId">
          <router-link
            :to="{
              path: `/newdetailed/${encodeURIComponent($route.fullPath)}`,
              query: {
                id: `${person.resourceId}`,
                pageNum: pageNum,
                newsTime: person.createTime
              }
            }"
          >
            <div class="leftLi">
              <h3>{{ person.createTime.slice(8, 10) }}</h3>
              <span class="yearMonth">{{ person.createTime.slice(0, 7) }}</span>
              <i></i>
            </div>
            <span class="newTitle">{{ person.title }}</span>
            <span class="newContent">{{ person.limitContent }}</span>
          </router-link>
        </li>
      </ul>
      <div
        v-if="arr.length == 0"
        style="text-align: center;padding-top:20vw;min-height: 100vh;font-size: 2.1333vw;color: #bbbbbb;"
      >
        暂无数据~
      </div>
    </div>
    <div class="pages">
      <el-pagination
        ref="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :pager-count="5"
        :current-page="pageNum"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="pageTotal"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      arr: [],
      status: 1,
      type: 1,
      arr: [],
      regex: /(<([^>]+)>)/gi,
      pageNum: 1, //页数
      pageSize: 4, //每页显示
      pageTotal: 0, //总共
      currentIndex: 0, //表示当前选项卡,
      list: [
        {
          id: 1, //用来代表每一个对象
          title: "最新消息", //标题
          gopath: ""
        },
        {
          id: 2,
          title: "集团公告", //标题
          gopath: "集团公告"
        },
        {
          id: 3,
          title: "信息披露", //标题
          gopath: "信息披露"
        },
        {
          id: 4,
          title: "公司动态", //标题
          gopath: "公司动态"
        }
      ]
    };
  },
  mounted() {
    // 这是通过传递query的pageNum页数信息，来判断回退的时候所在的位置地址
    if (this.$route.query.query) {
      console.log(this.$route.query.query);
      this.pageNum = JSON.parse(this.$route.query.query);
      console.log(this.pageNum);
      this.$nextTick(() => {
        this.$refs.pagination.internalCurrentPage = this.pageNum;
      });
      this.select();
    } else {
      this.select();
    }
  },
  methods: {
    change(index) {
      console.log(index);
      //用来实现切换功能
      //实现选项卡 切换操作 - 本质就是操作类名
      // 通过currentIndex操作
      this.currentIndex = index;
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;

      this.select();
    },
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
      console.log(this.pageNum);
      sessionStorage.setItem("currentPage", pageNum.toString());
      this.select();
    },
    open(index) {
      if (index === 2) {
        var nowStatus = document.getElementById("box-title");
        nowStatus.style.display = "none";
        (this.arr = []), (this.arr = this.arr2);
        console.log(this.arr[0].ri);
        nowStatus.style.display = "block";
      } else {
        (this.arr = []), (this.arr = this.arr2);
      }
    },
    select() {
      this.request
        .get(`/${this.status}/${this.type}`, {
          params: {
            pageSize: 4,
            pageNum: this.pageNum
          }
        })
        .then(res => {
          this.arr = res.data.data;
          console.log(this.arr);
          this.pageTotal = res.data.total;
          for (var i = 0; i < this.arr.length; i++) {
            this.arr[i].content = this.getSimpleText(this.arr[i].content);
          }
        });
    },
    select1() {
      this.arr = [];
      this.request
        .get(`/${this.status}/${this.type}`, {
          params: {
            pageSize: 4
          }
        })
        .then(res => {
          this.arr = res.data.data;
          this.pageTotal = res.data.total;
          for (var i = 0; i < this.arr.length; i++) {
            this.arr[i].content = this.arr[i].content.replace(this.regex, "");
          }
        });
    },
    select2(type) {
      console.log("巴黎贝甜");
      this.pageNum = 1;
      this.arr = [];
      console.log("!!!!!!!!!!!!!!");
      this.request
        .get(`/${this.status}/${this.type}`, {
          params: {
            pageSize: 4,
            category: type
          }
        })
        .then(res => {
          this.pageTotal = res.data.total;
          this.arr = res.data.data;
          for (var i = 0; i < this.arr.length; i++) {
            this.arr[i].content = this.getSimpleText(this.arr[i].content);
          }
        });
    },
    getSimpleText(html) {
      const re1 = new RegExp("<.+?>", "g"); // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      const arrEntities = {
        lt: "<",
        gt: ">",
        nbsp: " ",
        amp: "&",
        quot: '"',
        ldquo: "“",
        mdash: "—",
        rdquo: "”"
      };
      if (html) {
        return html
          .replace(re1, "")
          .replace(/&(lt|gt|nbsp|amp|quot|ldquo|mdash|rdquo);/gi, function(
            all,
            t
          ) {
            return arrEntities[t];
          });
      }
    }
  }
};
</script>

<style lang="less" scoped>
[v-cloak] {
  display: none;
}
button {
  border: none;
  background-color: transparent;
  outline: none;
}
/deep/ .el-pager li {
  min-width: 7.4667vw;
}
.pages {
  margin-top: 5.3333vw;
  text-align: center;
}
.top {
  height: 10.6667vw;
}
.top li {
  position: relative;
  float: left;
  display: inline-block;
  width: 25vw;
  height: 10.6667vw;
  line-height: 10.6667vw;
  text-align: center;
}
.top button {
  font-size: 3.2vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  text-align: center;
  color: #1d1d1d;
  opacity: 0.3;
}
.top .active button {
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #140047;
  opacity: 1;
}
.top .active i {
  text-align: center;
  position: absolute;
  left: 6.1333vw;
  bottom: 0.2667vw;
  width: 12.8vw;
  height: 0.4vw;
  border-radius: 0.2667vw;
  background-color: #140047;
}

.shownews ul li {
  position: relative;
  width: 92vw;
  height: 27.4667vw;
  margin: 4.1333vw auto 0vw;
  box-shadow: 0px 1px 10px 0px rgba(176, 183, 213, 0.2);
}
.shownews ul li .leftLi {
  width: 17.6vw;
  height: 27.4667vw;
  border-right: 1px solid #ecf0f2;
}
.shownews ul li h3 {
  position: absolute;
  top: 6.6667vw;
  left: 4.9333vw;
  font-size: 4.8vw;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  color: #1d1d1d;
  line-height: 5.6vw;
  letter-spacing: 0.2667vw;
}
.shownews ul li i {
  display: block;
  position: absolute;
  width: 2.2667vw;
  height: 0.2667vw;
  left: 5vw;
  top: 16vw;
  background-color: #ffa200;
}

.shownews ul li .yearMonth {
  position: absolute;
  display: block;
  top: 12.8vw;
  left: 0vw;
  height: 2.5333vw;
  font-size: 4.2667vw;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  color: #1d1d1d;
  line-height: 2.5333vw;
  letter-spacing: 0.1333vw;
  transform: scale(0.5);
  -webkit-transform: scale(0.5);
  opacity: 0.22;
}
.shownews ul {
  // min-height: 60.2533vh;
}
.shownews ul li .newTitle {
  display: block;
  width: 65.8667vw;
  height: 5.3333vw;
  line-height: 5.3333vw;
  position: absolute;
  // top: 5.6vw;
  top: 6.6vw;
  right: 4.2667vw;
  font-size: 3.7333vw;
  font-weight: 400;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #1d1e20;
  letter-spacing: 0.1333vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.shownews ul li .newContent {
  position: absolute;
  width: 65.8667vw;
  height: 8.8vw;
  // top: 13.0667vw;
  top: 14.0667vw;
  right: 4.2667vw;
  left: 21.8667vw;
  bottom: 5.6vw;
  font-size: 3.2vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d1d1d;
  line-height: 4.5333vw;
  letter-spacing: 0.1333vw;
  overflow: hidden;
  opacity: 0.44;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/news/news1.vue